import PageHeader from '../../components/PageHeader';
import FilterPanel from '../../components/FilterPanel';
import DataTable from '../../components/DataTable';
import { formatDate, placeLabel } from '../../utils/formatters';
import { Button, Typography, Stack, TextField } from '@mui/material';
const getLoadScoreClassName = (loadScore) => {
  if (loadScore <= 4) return 'calm';
  if (loadScore <= 6) return 'medium';
  if (loadScore <= 8) return 'busy';
  return 'very-busy';
};
const columns = [
  {
    key: 'place',
    label: 'מקום',
    render: (report) => placeLabel(report.place),
  },
  {
    key: 'reporter',
    label: 'מדווח',
    render: (report) => report.reporter?.userId || report.anonymousId || report.deviceId || '-',
  },
  {
    key: 'source',
    label: 'מקור',
    render: (report) => report.source,
  },
  {
    key: 'loadScore',
    label: 'עומס',
    render: (report) => (
      <Typography
        sx={String(`load-score load-score-${getLoadScoreClassName(report.loadScore)}`)
          .split(/\s+/)
          .map(
            (name) =>
              ({
                'load-score': {
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  minWidth: '32px',
                  minHeight: '28px',
                  borderRadius: '999px',
                  padding: '2px 10px',
                  fontWeight: '800',
                },
                'load-score-calm': {
                  background: '#dcfae6',
                  color: '#067647',
                },
                'load-score-medium': {
                  background: '#fff6d6',
                  color: '#b54708',
                },
                'load-score-busy': {
                  background: '#ffead5',
                  color: '#c4320a',
                },
                'load-score-very-busy': {
                  background: '#fee4e2',
                  color: '#b42318',
                },
              })[name],
          )
          .filter(Boolean)}
      >
        {report.loadScore}
      </Typography>
    ),
  },
  {
    key: 'createdAt',
    label: 'נוצר',
    render: (report) => formatDate(report.createdAt),
  },
  {
    key: 'validUntil',
    label: 'בתוקף עד',
    render: (report) => formatDate(report.validUntil),
  },
];
const ReportsPage = ({ reports, filters, setFilters, loadReports, loading }) => {
  return (
    <Stack
      sx={{
        gap: '22px',
        height: '100%',
        overflow: 'hidden',
      }}
    >
      <PageHeader title={'דיווחים'} meta={`(${reports.total})`}>
        <FilterPanel>
          <TextField
            type="date"
            value={filters.from}
            onChange={(e) =>
              setFilters({
                ...filters,
                from: e.target.value,
              })
            }
            fullWidth
          />
          <TextField
            type="date"
            value={filters.to}
            onChange={(e) =>
              setFilters({
                ...filters,
                to: e.target.value,
              })
            }
            fullWidth
          />
          <TextField
            placeholder="Place ID"
            value={filters.placeId}
            onChange={(e) =>
              setFilters({
                ...filters,
                placeId: e.target.value,
              })
            }
            fullWidth
          />
          <TextField
            placeholder="Source"
            value={filters.source}
            onChange={(e) =>
              setFilters({
                ...filters,
                source: e.target.value,
              })
            }
            fullWidth
          />
          <Button onClick={() => loadReports(1)}>סינון</Button>
        </FilterPanel>
      </PageHeader>

      <DataTable
        columns={columns}
        items={reports.items}
        rowKey={(report) => report._id || report.id}
        page={reports.page}
        limit={reports.limit}
        total={reports.total}
        onPageChange={loadReports}
        loading={loading}
      />
    </Stack>
  );
};
export default ReportsPage;
